module.exports = __webpack_public_path__ + "static/img/gaotie.0b728bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/gaotie.png
// module id = M9NS
// module chunks = 1